export const ADD_TO_ALERT_STARTED = 'ADD_TO_ALERT_STARTED';
export const ADD_TO_ALERT_SUCCESS = 'ADD_TO_ALERT_SUCCESS';
export const ADD_TO_ALERT_FAILURE = 'ADD_TO_ALERT_FAILURE';

export const OP_ALERT_STARTED = 'OP_ALERT_STARTED';
export const OP_ALERT_COMPLETED = 'OP_ALERT_COMPLETED';

export const UPDATE_ALERT_STARTED = 'UPDATE_ALERT_STARTED';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const UPDATE_ALERT_FAILURE = 'UPDATE_ALERT_FAILURE';

export const REMOVE_FROM_SEARCH_ALERTS_STARTED = 'REMOVE_FROM_SEARCH_ALERTS_STARTED';
export const REMOVE_FROM_SEARCH_ALERTS_SUCCESS = 'REMOVE_FROM_SEARCH_ALERTS_SUCCESS';
export const REMOVE_FROM_SEARCH_ALERTS_FAILURE = 'AREMOVE_FROM_SEARCH_ALERTS_FAILURE';